import styled from 'styled-components';

export const UpdatedDialogContainer = styled.section`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(50, 51, 56, 0.35);
  z-index: 10;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UpdatedDialogView = styled.dialog`
  z-index: 1;
  position: relative;
  border: none;
  height: fit-content;
  width: fit-content;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  .content__container {
    @media only screen and (min-width: 768px) {
      ${({ fullWidth }) => (fullWidth ? 'width: 100%' : '')};
      padding-left: ${({ padding }) => (padding ? padding : '3rem')};
      padding-right: ${({ padding }) => (padding ? padding : '3rem')};
    }
    @media only screen and (max-width: 768px) {
      width: 92%;
    }
  }

  @media only screen and (max-width: 768px) {
    width: 92%;
  }

  @media only screen and (min-width: 768px) {
    width: 500px;
  }

  .close__icon {
    cursor: pointer;
    padding: 4px;
    margin-left: auto;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }
  .header-spacing {
    padding: 16px;
  }
`;
